import { Tag } from 'rsuite';
import styled from 'styled-components';

export default styled(Tag)`
  padding: 2px 5px;
  border: 1px solid #ddd;
  & + .rs-tag {
    margin-left: 3px;
  }
`;
